import { caseTemplateSchema } from "@/components/Forms/schema/caseTemplateSchema.ts";
import useAuthenticatedFetch from "@/hooks/useAuthenticatedFetch.ts";
import { apiUrl } from "@/utils/api.ts";
import { type UseQueryResult, useQuery } from "@tanstack/react-query";
import { createResourceCollectionSelector } from "jsonapi-zod-query";

const caseTemplateTypeSelector = createResourceCollectionSelector({
    type: "caseTemplate",
    attributesSchema: caseTemplateSchema,
});

export type CaseTemplate = ReturnType<typeof caseTemplateTypeSelector>;

type Props = {
    searchString: string;
    isQueryEnabled?: boolean;
    subQueryKey?: string;
};

export const useFetchCaseTemplatesForAutocomplete = ({
    searchString,
    isQueryEnabled = true,
    subQueryKey = "case-template-autocomplete",
}: Props): UseQueryResult<CaseTemplate> => {
    const fetch = useAuthenticatedFetch();

    return useQuery({
        refetchOnWindowFocus: false,
        queryKey: [searchString, subQueryKey],
        enabled: isQueryEnabled,
        queryFn: async () => {
            const fetchURL = apiUrl("/case-template/search");

            const response = await fetch(fetchURL.href, {
                method: "POST",
                headers: {
                    "Content-Type": "application/vnd.api+json",
                },
                body: JSON.stringify({
                    searchString: searchString,
                }),
            });

            return await response.json();
        },
        select: caseTemplateTypeSelector,
    });
};
